import { Stack } from 'expo-router';
import React from 'react';

import { ImOpsPage } from '../../im-ops/components/ImOpsPage';

export default function ImOpsIndexPage() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Investment Management Operations',
                }}
            />
            <ImOpsPage />
        </>
    );
}
